import UserSessionService from "./UserSessionService";
import CountrySearchResponse from "../domain/CountrySearchResponse";
import WsService from "./WsService";

const ENDPOINT_BASE = "/transactions/country";

export default class CountryService {

    static retrieveCountriesForTransaction() {

        let transactionHeaders = UserSessionService.retrieveTransactingHeaders();

        let headers = {
            ...transactionHeaders
        };

        return WsService.getWithHeaders(ENDPOINT_BASE, {}, 200, headers).then(
            response => {
                let responseArr = [];
                response[0].countries.forEach(singleCountry => {
                    responseArr.push(new CountrySearchResponse(singleCountry))
                });
                return responseArr;
            },
            response => {
                return response;
            }
        )

    }

}